import React from "react";
import PropTypes from "prop-types";
import { Tabs } from "@learningblocks/storybook-components";
import { Description } from "./Description";
import { Title } from "./Title";
import "./style.scss";

const TAB = {
  STEPS: "STEPS",
  TECHNIQUES: "TECHNIQUES",
};
/**
 * ViewTabPane:
 *  - TabPane displayed on content-area of TabPane.
 *    The pane display a title and description of the view or design-view in general
 *    User can select a tab to more between different view
 */
export function ViewTabPane(props) {
  const onTabClicked = (tab) => props.onTabSelect(tab);
  const { availableViewTypes = ["STEPS", "TECHNIQUES"], viewDisplayNames = { STEPS: 'Steps', TECHNIQUES: 'Techniques' } } = props;

  React.useEffect(() => {
    const element = document.querySelector("." + "toggleTabView_menuList");
    if (element) {
      element.scrollIntoView({ block: "start" });
    }
  }, [props.current]);

  // Ensure we have at least one valid view type, fallback to both if empty
  const validViewTypes = availableViewTypes.length > 0 ? availableViewTypes : ["STEPS", "TECHNIQUES"];

  const className = `toggleTabView ${props.className}`;

  // Build menu items array to avoid conditional rendering issues in Tabs.List
  const menuItems = [];

  if (validViewTypes.includes(TAB.STEPS)) {
    menuItems.push(
      <Tabs.Menu
        tabIndex={props.tabIndex}
        className="toggleTabView_menuList--menu"
        onClick={onTabClicked}
        value={TAB.STEPS}
        key="0"
      >
        {viewDisplayNames.STEPS}
      </Tabs.Menu>
    );
  }

  if (validViewTypes.includes(TAB.TECHNIQUES)) {
    menuItems.push(
      <Tabs.Menu
        tabIndex={props.tabIndex}
        className="toggleTabView_menuList--menu"
        onClick={onTabClicked}
        value={TAB.TECHNIQUES}
        key="1"
      >
        {viewDisplayNames.TECHNIQUES}
      </Tabs.Menu>
    );
  }

  return (
    <Tabs.Tabs className={className} default={props.current}>
      <Tabs.List className="toggleTabView_menuList">
        {menuItems}
      </Tabs.List>
      {validViewTypes.includes(TAB.STEPS) && (
        <Tabs.Panel
          key="0"
          menuValue={TAB.STEPS}
          className="toggleTabView_tabContent"
        >
          <Title text={props.title} />
          <Description content={props.description} />
        </Tabs.Panel>
      )}
      {validViewTypes.includes(TAB.TECHNIQUES) && (
        <Tabs.Panel
          key="1"
          menuValue={TAB.TECHNIQUES}
          className="toggleTabView_tabContent"
        >
          <Title text={props.title} />
          <Description content={props.description} />
        </Tabs.Panel>
      )}
    </Tabs.Tabs>
  );
}

ViewTabPane.propTypes = {
  /**
   * Titile of the Toggle tab component
   */
  title: PropTypes.string.isRequired,
  /**
   * Description array which may contain more than one paragraph of content to display in ViewTabPane
   */
  description: PropTypes.arrayOf(PropTypes.string).isRequired,
  /**
   * style to recive from out of the component
   */
  className: PropTypes.string,
  /**
   * is it StepsView or TechniquesView that is displayed below is set using currentView
   */
  current: PropTypes.oneOf(["STEPS", "TECHNIQUES"]).isRequired,
  /**
   * Function to invoke when a Tab is Selected
   */
  onTabSelect: PropTypes.func.isRequired,
  /**
   * for keyboard navigation
   */
  tabIndex: PropTypes.number,
  /**
   * Array of available view types to determine which tabs to show
   */
  availableViewTypes: PropTypes.arrayOf(PropTypes.oneOf(["STEPS", "TECHNIQUES"])),
};

ViewTabPane.defaultProps = {
  title: "",
  description: "",
};
